.asset-bounding-box{display:block;padding-top:7px}
/*# sourceMappingURL=modify-asset-bounding-box.component.css.map */
